export default __webpack_public_path__ + "static/media/icecreamcounting.7b0f87c5.png";